module.exports = __webpack_public_path__ + "static/media/hero-william-merritt-chase-painting.69020248.jpeg";